import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AirportService as AirportServiceModel } from '../../model/airportService';

@Injectable({
  providedIn: 'root'
})
export class AirportServicesService {
  private endpoint = '/airport-services';

  constructor(private http: HttpClient) {}

  getByAirportId(airportId: number): Observable<AirportServiceModel> {
    return this.http.get<AirportServiceModel>(`${environment.apiUrl}${this.endpoint}/${airportId}`);
  }

  save(data: AirportServiceModel): Observable<AirportServiceModel> {
    return this.http.post<AirportServiceModel>(`${environment.apiUrl}${this.endpoint}`, data);
  }

  delete(airportId: number): Observable<void> {
    return this.http.delete<void>(`${environment.apiUrl}${this.endpoint}/${airportId}`);
  }
}
